import { TrendingUp, TrendingDown, Minus } from "lucide-react";

export default function DeltaBadge({ value, className = "" }) {
  const v = Number(value) || 0;
  const up = v > 0, down = v < 0;
  const Icon = up ? TrendingUp : down ? TrendingDown : Minus;
  const tone = up ? "text-emerald-600 bg-emerald-50" : down ? "text-rose-600 bg-rose-50" : "text-muted-foreground bg-muted";
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold ${tone} ${className}`}>
      <Icon className="h-3 w-3" />
      {v > 0 ? "+" : ""}{v}%
    </span>
  );
}
